document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-nursery-registration]').forEach(function (section) {
    var success = section.querySelector('[data-form-success]');

    if (success) {
      success.focus();
      section
        .querySelector('.ip-nursery-registration__form-shell')
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
});